import { Injectable } from '@angular/core';
import { RegexValidatorModel, ControlValidatorError } from '../types/validator.types';
import { cloneDeep } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class RegexValidatorPatternService {
  regex: RegexValidatorModel[] = [
    {
      name: 'email',
      text: 'Email',
      expression: '^\\w+((-\\w+)|(\\.\\w+))*\\@[A-Za-z0-9]+((\\.|-)[A-Za-z0-9]+)*\\.[A-Za-z0-9]+$',
      errorMessage: 'Emailæ ¼å¼æ ¡éªéè¯¯'
    },
    {
      name: 'qqNo',
      text: 'QQå·',
      expression: '^[1-9][0-9]{4,10}$',
      errorMessage: 'QQå·æ ¼å¼æ ¡éªéè¯¯'
    },
    {
      name: 'url',
      text: 'ç½å',
      expression: `^(https?|ftp|file):\\/\\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]`,
      errorMessage: 'ç½åæ ¼å¼æ ¡éªéè¯¯'
    },
    {
      name: 'mobilePhone',
      text: 'ææºå·',
      expression:
        // æ¯æ +86/0086/86/0/17951 åç¼ï¼å·æ®µè¦ç 13xã145-149ã15xã162/165-167ã17xã18xã19xï¼æé¤ 140-144 ç©èç½å·æ®µï¼
        '^(?:\\+?86|0086|86|0|17951)?1(?:3\\d|4[5-9]|5\\d|6[2567]|7\\d|8\\d|9\\d)\\d{8}$',
      errorMessage: 'ææºå·æ ¼å¼æ ¡éªéè¯¯'
    },
    {
      name: 'postNo',
      text: 'é®æ¿ç¼ç ',
      expression: '^[1-9][0-9]{5}$',
      errorMessage: 'é®æ¿ç¼ç æ ¼å¼æ ¡éªéè¯¯'
    },

    {
      name: 'ipAddress',
      text: 'IPå°å',
      expression:
        // tslint:disable-next-line: max-line-length
        '^(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])$',
      errorMessage: 'IPå°åæ ¼å¼æ ¡éªéè¯¯'
    },

    {
      name: 'idCard',
      text: 'èº«ä»½è¯',
      expression:
        // tslint:disable-next-line: max-line-length
        '^([1-9]\\d{5}(18|19|([23]\\d))\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{3}[0-9Xx]$)|(^[1-9]\\d{5}\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{3})$',
      errorMessage: 'èº«ä»½è¯æ ¼å¼æ ¡éªéè¯¯',
      validate: (value: any) => {
        return new ControlValidatorError(this.idCardNoUtil.checkIdCardNo(value), '');
      }
    }
  ];

  constructor() {
    this.regex.push({ name: 'custom', text: 'èªå®ä¹', expression: '', errorMessage: '' });
  }

  getValidatorModels(): RegexValidatorModel[] {
    return cloneDeep(this.regex);
  }

  /**
   * @description èº«ä»½è¯å·ç å¤ç
   *
   * @memberof RegexValidatorPatternService
   */
  idCardNoUtil = {
    /*ç,ç´è¾å¸ä»£ç è¡¨*/
    provinceAndCitys: {
      11: 'åäº¬',
      12: 'å¤©æ´¥',
      13: 'æ²³å',
      14: 'å±±è¥¿',
      15: 'åèå¤',
      21: 'è¾½å®',
      22: 'åæ',
      23: 'é»é¾æ±',
      31: 'ä¸æµ·',
      32: 'æ±è',
      33: 'æµæ±',
      34: 'å®å¾½',
      35: 'ç¦å»º',
      36: 'æ±è¥¿',
      37: 'å±±ä¸',
      41: 'æ²³å',
      42: 'æ¹å',
      43: 'æ¹å',
      44: 'å¹¿ä¸',
      45: 'å¹¿è¥¿',
      46: 'æµ·å',
      50: 'éåº',
      51: 'åå·',
      52: 'è´µå·',
      53: 'äºå',
      54: 'è¥¿è',
      61: 'éè¥¿',
      62: 'çè',
      63: 'éæµ·',
      64: 'å®å¤',
      65: 'æ°ç',
      71: 'å°æ¹¾',
      81: 'é¦æ¸¯',
      82: 'æ¾³é¨',
      91: 'å½å¤'
    },

    /*æ¯ä½å æå å­*/
    powers: ['7', '9', '10', '5', '8', '4', '2', '1', '6', '3', '7', '9', '10', '5', '8', '4', '2'],

    /*ç¬¬18ä½æ ¡æ£ç */
    parityBit: ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'],

    /*æ§å«*/
    genders: { male: 'ç·', female: 'å¥³' },

    /*æ ¡éªå°åç */
    checkAddressCode: function (addressCode: any) {
      const check = /^[1-9]\d{5}$/.test(addressCode);
      if (!check) return false;
      if (this.provinceAndCitys[parseInt(addressCode.substring(0, 2), 10)]) {
        return true;
      } else {
        return false;
      }
    },

    /*æ ¡éªæ¥æç */
    checkBirthDayCode: function (birDayCode: any) {
      const check = /^[1-9]\d{3}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))$/.test(birDayCode);
      if (!check) return false;
      const yyyy = parseInt(birDayCode.substring(0, 4), 10);
      const mm = parseInt(birDayCode.substring(4, 6), 10);
      const dd = parseInt(birDayCode.substring(6), 10);
      const xdata = new Date(yyyy, mm - 1, dd);
      if (xdata > new Date()) {
        return false; // çæ¥ä¸è½å¤§äºå½åæ¥æ
      } else if (xdata.getFullYear() === yyyy && xdata.getMonth() === mm - 1 && xdata.getDate() === dd) {
        return true;
      } else {
        return false;
      }
    },

    /*è®¡ç®æ ¡æ£ç */
    getParityBit: function (idCardNo: any) {
      const id17 = idCardNo.substring(0, 17);
      /*å æ */
      let power = 0;
      for (let i = 0; i < 17; i++) {
        power += parseInt(id17.charAt(i), 10) * parseInt(this.powers[i], 10);
      }
      /*åæ¨¡*/
      const mod = power % 11;
      return this.parityBit[mod];
    },

    /*éªè¯æ ¡æ£ç */
    checkParityBit: function (idCardNo: any) {
      const parityBit = idCardNo.charAt(17).toUpperCase();
      if (this.getParityBit(idCardNo) === parityBit) {
        return true;
      } else {
        return false;
      }
    },

    /*æ ¡éª15ä½æ18ä½çèº«ä»½è¯å·ç */
    checkIdCardNo: function (idCardNo: any) {
      // 15ä½å18ä½èº«ä»½è¯å·ç çåºæ¬æ ¡éª
      const check = /^\d{15}|(\d{17}(\d|x|X))$/.test(idCardNo);
      if (!check) return false;
      // å¤æ­é¿åº¦ä¸º15ä½æ18ä½
      if (idCardNo.length === 15) {
        return this.check15IdCardNo(idCardNo);
      } else if (idCardNo.length === 18) {
        return this.check18IdCardNo(idCardNo);
      } else {
        return false;
      }
    },

    // æ ¡éª15ä½çèº«ä»½è¯å·ç 
    check15IdCardNo: function (idCardNo: any) {
      // 15ä½èº«ä»½è¯å·ç çåºæ¬æ ¡éª
      let check = /^[1-9]\d{7}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}$/.test(idCardNo);
      if (!check) return false;
      // æ ¡éªå°åç 
      const addressCode = idCardNo.substring(0, 6);
      check = this.checkAddressCode(addressCode);
      if (!check) return false;
      const birDayCode = '19' + idCardNo.substring(6, 12);
      // æ ¡éªæ¥æç 
      return this.checkBirthDayCode(birDayCode);
    },

    // æ ¡éª18ä½çèº«ä»½è¯å·ç 
    check18IdCardNo: function (idCardNo: any) {
      // 18ä½èº«ä»½è¯å·ç çåºæ¬æ ¼å¼æ ¡éª
      let check = /^[1-9]\d{5}[1-9]\d{3}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}(\d|x|X)$/.test(
        idCardNo
      );
      if (!check) return false;
      // æ ¡éªå°åç 
      const addressCode = idCardNo.substring(0, 6);
      check = this.checkAddressCode(addressCode);
      if (!check) return false;
      // æ ¡éªæ¥æç 
      const birDayCode = idCardNo.substring(6, 14);
      check = this.checkBirthDayCode(birDayCode);
      if (!check) return false;
      // éªè¯æ ¡æ£ç 
      return this.checkParityBit(idCardNo);
    },

    formateDateCN: function (day: any) {
      const yyyy = day.substring(0, 4);
      const mm = day.substring(4, 6);
      const dd = day.substring(6);
      return yyyy + '-' + mm + '-' + dd;
    },

    // è·åä¿¡æ¯
    getIdCardInfo: function (idCardNo: any) {
      const idCardInfo = {
        gender: '', // æ§å«
        birthday: '' // åºçæ¥æ(yyyy-mm-dd)
      };
      if (idCardNo.length === 15) {
        const aday = '19' + idCardNo.substring(6, 12);
        idCardInfo.birthday = this.formateDateCN(aday);
        if (parseInt(idCardNo.charAt(14), 10) % 2 === 0) {
          idCardInfo.gender = this.genders.female;
        } else {
          idCardInfo.gender = this.genders.male;
        }
      } else if (idCardNo.length === 18) {
        const aday = idCardNo.substring(6, 14);
        idCardInfo.birthday = this.formateDateCN(aday);
        if (parseInt(idCardNo.charAt(16), 10) % 2 === 0) {
          idCardInfo.gender = this.genders.female;
        } else {
          idCardInfo.gender = this.genders.male;
        }
      }
      return idCardInfo;
    },

    /*18ä½è½¬15ä½*/
    getId15: function (idCardNo: any) {
      if (idCardNo.length === 15) {
        return idCardNo;
      } else if (idCardNo.length === 18) {
        return idCardNo.substring(0, 6) + idCardNo.substring(8, 17);
      } else {
        return null;
      }
    },

    /*15ä½è½¬18ä½*/
    getId18: function (idCardNo: any) {
      if (idCardNo.length === 15) {
        const id17 = idCardNo.substring(0, 6) + '19' + idCardNo.substring(6);
        const parityBit = this.getParityBit(id17);
        return id17 + parityBit;
      } else if (idCardNo.length === 18) {
        return idCardNo;
      } else {
        return null;
      }
    }
  };
}
